import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { BusinessType, BusinessTypeService } from '@app/core/business-type';

@Component({
  selector: 'filter-client-types',
  templateUrl: './filter-client-types.component.html',
  styleUrls: ['./filter-client-types.component.scss'],
})
export class FilterClientTypesComponent implements OnInit {
  constructor(public businessTypeSvc :BusinessTypeService) {}
  @Input() value :number[] | number;
  @Input() label :string = 'Client Type';
  @Output() changeClientTypes :EventEmitter<number[] | number> = new EventEmitter<
    number[] | number
  >();
  @Input() options :{ multi :boolean } = { multi: false };

  clientTypes :BusinessType[];
  unsubscribeBusinessTypeSvc :Subscription;

  ngOnInit() :void {
    this.loadClientTypes();
  }

  ngOnDestroy() :void {
    if (this.unsubscribeBusinessTypeSvc) {
      this.unsubscribeBusinessTypeSvc.unsubscribe();
    }
  }

  onChange() :void {
    this.changeClientTypes.emit(this.value);
  }

  private loadClientTypes() :void {
    this.unsubscribeBusinessTypeSvc = this.businessTypeSvc.businessTypes$.subscribe(
      (res) => {
        this.clientTypes = res;
      },
    );
  }
}
